import outdent from 'outdent'

export const renderHelpText = () => {
  return outdent`
  // inputs: The action inputs
  // state: Persistence between executions
  // client: An authenticated client`
}

export const defaultActions = (authTypes?: string[]) => {
  const authAction = {
    inputs: { type: 'object', properties: {}, required: [] },
    perform: outdent`
      ${renderHelpText()}

      const { baseUrl } = inputs
      const response = await client.fetch(new URL('ENTER PATH', baseUrl))
      let responseData = await response.text()
      try {
        responseData = JSON.parse(responseData)
      } catch {}

      export default response.ok && !!responseData
      `
  }
  let _getOauthUrl
  if (authTypes?.includes('oauth2')) {
    _getOauthUrl = {
      inputs: { type: 'object', properties: {}, required: [] },
      perform: outdent`
      ${renderHelpText()}
      const params = new URLSearchParams({
        "grant_type": 'authorization_code',
        "response_type": 'code',
        "redirect_uri": inputs.redirectUrl,
        "state": inputs.state,
        "client_id": inputs.clientId
      }).toString()

      const oauthUrl = \`\${inputs.baseUrl}/[ENTER OAUTH AUTHORIZATION URL PATH]?\${params}\`

      export default { oauthUrl }

      `
    }
  }
  return {
    _ping: {
      perform: outdent`
      ${renderHelpText()}

      const { baseUrl } = inputs
      const response = await client.fetch(new URL('ENTER PATH', baseUrl))
      export default await response.json()
      `
    },
    _auth: authAction,
    ...(authTypes?.includes('oauth2') && { _getOauthUrl })
  }
}

export const requiredActionKeys = new Set(['_ping', '_auth', '_getOauthUrl', '_proxy'])
